var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectAttendeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 21.5999C8.05844 21.5999 7.77344 21.4849 7.54344 21.2549C7.31344 21.0249 7.19844 20.7399 7.19844 20.3999V17.9999H22.7984V7.1999H25.1984C25.5384 7.1999 25.8234 7.3149 26.0534 7.5449C26.2834 7.7749 26.3984 8.0599 26.3984 8.3999V26.3999L21.5984 21.5999H8.39844ZM2.39844 20.3999V3.5999C2.39844 3.2599 2.51344 2.9749 2.74344 2.7449C2.97344 2.5149 3.25844 2.3999 3.59844 2.3999H19.1984C19.5384 2.3999 19.8234 2.5149 20.0534 2.7449C20.2834 2.9749 20.3984 3.2599 20.3984 3.5999V14.3999C20.3984 14.7399 20.2834 15.0249 20.0534 15.2549C19.8234 15.4849 19.5384 15.5999 19.1984 15.5999H7.19844L2.39844 20.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectAttendeeIcon);
export default __webpack_public_path__ + "static/media/DirectAttendeeIcon.4a8da9062659deddb73dcc42b6b312f6.svg";
export { ForwardRef as ReactComponent };